export const FILL = "fill";
export const FIT = "fit";